import type { Action } from 'labstep-web/models/action.model';
import { normalizeEntities } from 'labstep-web/services/normalize';

export const getIdTimestamp = (
  id: number | string,
  timestamp?: string,
): string | number => (timestamp ? `${id}-${timestamp}` : id);

/**
 * Normalize entity with timestamp
 * Replaces id and guid with original id and guid
 * @param action Action
 * @returns Normalized payload
 */
export const normalizeEntityWithTimestamp = (
  action: Action,
): Record<string, unknown> => {
  const payload = { ...(action.payload as any) };
  const className = action.meta!.normalize;
  const timestamp = (action.meta!.params as any).at;
  const normalizedPayload = normalizeEntities(
    {
      ...payload,
      id: getIdTimestamp(payload.id as any, timestamp),
      guid: getIdTimestamp(payload.guid as any, timestamp),
    },
    className as string,
  );
  const { result, entities } = normalizedPayload;
  const normalizedPayloadWithIdAndGuidReset = {
    ...normalizedPayload,
    entities: {
      ...entities,
      [className as string]: {
        ...entities[className as string],
        [result]: {
          ...entities[className as string][result],
          id: payload.id,
          guid: payload.guid,
        },
      },
    },
  };
  return normalizedPayloadWithIdAndGuidReset;
};
